import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router'
import { TableModule } from 'primeng/table';
import { DataTableModule } from 'primeng/primeng';
import { PanelModule } from 'primeng/panel';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { FileUploadModule } from 'primeng/fileupload';
import { DropdownModule } from 'primeng/dropdown';
// import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { CalendarModule } from 'primeng/calendar';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { GrowlModule } from 'primeng/growl';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { AccordionModule } from 'primeng/accordion';
import { StepsModule } from 'primeng/steps';
import { AppComponent } from './app.component';
import { UserService } from './shared/user.service';
//import { Page1Service } from './page1/Page1.Service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { UserComponent } from './user/user.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { HomeComponent } from './home/home.component';
import { SignUpComponent } from './user/sign-up/sign-up.component';
import { appRoutes } from './routes';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { Page1Component } from './page1/page1.component';
import { MenuComponent } from './menu/menu.component';
import { UserDetailComponent } from './user/user-detail/user-detail.component';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { TabViewModule } from 'primeng/tabview';
import { PaginatorModule } from 'primeng/paginator';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ErrorPageComponent } from './error-page/error-page.component';
import { MainPageComponent } from './main-page/main-page.component';
import { UserManagementService } from './service/user-management.service';
// import { RecipientManagementService } from './service/recipient-management.service';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {InputTextModule} from 'primeng/inputtext';
import {KeyFilterModule} from 'primeng/keyfilter';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
//import { EditorModule } from 'primeng/editor';
// import { TripCyclesComponent } from './trip-cycles/trip-cycles.component';
// import { TripCycleDetailsComponent } from './trip-cycle-details/trip-cycle-details.component';
import { TripService } from './service/trip.service';
import { TripPaymentCardsDetailsVFSuccessComponent } from './tip-card-change/TripPaymentCardsDetailsVFSuccess/TripPaymentCardsDetailsVFSuccess.component';
import { TripPaymentCardsDetailsVFErrorComponent } from './tip-card-change/TripPaymentCardsDetailsVFError/TripPaymentCardsDetailsVFError.component';
import { TripPaymentCardsDetailsVFCancelComponent } from './tip-card-change/TripPaymentCardsDetailsVFCancel/TripPaymentCardsDetailsVFCancel.component';
import { TripCycles2Component } from './trip-cycles-2/trip-cycles-2.component';
import { TripCycleDetails2Component } from './trip-cycle-details-2/trip-cycle-details-2.component';



@NgModule({
  declarations: [
    AppComponent,
    SignUpComponent,
    UserComponent,
    SignInComponent,
    HomeComponent,
    Page1Component,
    MenuComponent,
    UserDetailComponent,
    ErrorPageComponent,
    MainPageComponent,
    // TripCyclesComponent,
    TripCycles2Component,
    // TripCycleDetailsComponent,
    TripCycleDetails2Component,
    TripPaymentCardsDetailsVFSuccessComponent,
    TripPaymentCardsDetailsVFErrorComponent,
    TripPaymentCardsDetailsVFCancelComponent,
    
 ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    TableModule,
    PanelModule,
    AutoCompleteModule,
    FileUploadModule,
    DropdownModule,
    CalendarModule,
    ListboxModule,
    MultiSelectModule,
    GrowlModule,
    CheckboxModule,
    DialogModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    TooltipModule,
    AccordionModule,
    DataTableModule,
    TabViewModule,
    PaginatorModule,
    StepsModule,
    SelectButtonModule,
    InputTextareaModule,
    InputTextModule,
    KeyFilterModule,
    MessagesModule,
    MessageModule,
    ConfirmDialogModule
    //EditorModule
  ],
  providers: [UserService, /*Page1Service,*/ UserManagementService, TripService, AuthGuard, ConfirmationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/app.module.ts